import type { Schema } from '@wix/wix-data-schema-types'
import { formatFields } from '../utils/formatFields'
import { createCollectionFields } from './createCollectionFields'

export const getCollectionFields = ({
  schema,
  isFromExistingCollection = false,
}: {
  schema: Schema
  isFromExistingCollection?: boolean
}) => {
  const formattedFields = formatFields({
    rawFields: schema.fields,
    isFromExistingCollection,
  })

  const collectionFields = createCollectionFields(formattedFields)

  return {
    collectionFields,
    formattedFields,
  }
}
